const API_BASE = '/api'

export async function apiFetch<T = any>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const url = `${API_BASE}${path}`
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string>),
  }

  const csrfToken = getCookie('csrftoken')
  if (csrfToken && options.method && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(options.method)) {
    headers['X-CSRF-Token'] = csrfToken
  }

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: 'include',
  })

  if (!response.ok) {
    const text = await response.text().catch(() => '')
    let message = friendlyStatus(response.status)
    try {
      const json = JSON.parse(text)
      if (json.message) message = json.message
      else if (json.error) message = json.error
    } catch {
      // text is not JSON — ignore raw status strings like "HTTP 401 Unauthorized"
    }
    throw new Error(message)
  }

  if (response.status === 204) return undefined as T

  return response.json()
}

function friendlyStatus(status: number): string {
  switch (status) {
    case 400: return 'Something was wrong with that request. Check it and try again.'
    case 401: return 'Incorrect email or password. Please try again.'
    case 403: return "You don't have permission to do that."
    case 404: return "We couldn't find what you were looking for."
    case 409: return 'That conflicts with something that already exists.'
    case 429: return 'Too many attempts. Wait a moment and try again.'
    default: return 'Something went wrong. Please try again.'
  }
}

function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`))
  return match ? match[2] : null
}
